import React, { useContext } from 'react'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { useDispatch } from 'react-redux'
import { StackNavigationProp } from '@react-navigation/stack'
import { BottomSheet } from '@src/components'
import { Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { AppStackParamList } from '@src/navigation/types'
import { NavigatorContext, useDispatchAsync, useSnack } from '@src/utils'
import { ErrorMessages } from '@src/config'

export const CancelRecurringAppointmentModal = () => {
  const styles = useStyleSheet(themedStyles)
  const dispatch = useDispatch()
  const dispatchAsync = useDispatchAsync()
  const route = useRoute<RouteProp<AppStackParamList, 'CancelRecurringAppointmentModal'>>()

  const { videoCallId, appointmentDate } = route.params
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const { enableLoader, disableLoader } = useContext(NavigatorContext)
  const showSnack = useSnack()

  const onCancelOnlyPress = () => {
    enableLoader()
    dispatch({
      type: 'nutritionistHub/cancelAppointment',
      payload: {
        id: videoCallId,
      },
      success: () => {
        navigation.replace('Drawer', { screen: 'Dashboard', params: { screen: 'NutritionistHub' } })
      },
      failure: (error: any) => {
        const errorMessage = error?.message || ErrorMessages.ServerError
        showSnack(errorMessage, null, 'error', 'x', undefined, 'redesigned')
      },
      complete: () => {
        disableLoader()
      },
    })
  }

  const onCancelAllPress = async () => {
    try {
      enableLoader()

      await dispatchAsync({
        type: 'nutritionistHub/cancelAppointment',
        payload: {
          id: videoCallId,
        },
      })
      await dispatchAsync({
        type: 'nutritionistHub/deleteAppointmentRecurrence',
        payload: {
          baseStartDate: appointmentDate,
        },
      })

      navigation.replace('Drawer', { screen: 'Dashboard', params: { screen: 'NutritionistHub' } })
    } catch (error: any) {
      const errorMessage = error?.message || ErrorMessages.ServerError
      showSnack(errorMessage, null, 'error', 'x', undefined, 'redesigned')
    } finally {
      disableLoader()
    }
  }

  return (
    <BottomSheet
      primaryButton={{ text: 'This Appointment', onPress: onCancelOnlyPress }}
      secondaryButton={{ text: 'This and Future Appointments', onPress: onCancelAllPress }}
      buttonDirection="column-reverse"
      showDismissButton
      dismissButtonPosition="top"
    >
      <Text style={styles.title} type="title-2">
        You are canceling a recurring appointment
      </Text>
      <Text style={styles.content} type="regular">
        Do you want to cancel only this appointment or this and all appointments that occur after
        it?
      </Text>
      <Text style={[styles.content, { marginTop: 8 }]} type="small">
        Appointments that occur within the next 24 hours will not be canceled
      </Text>
    </BottomSheet>
  )
}

const themedStyles = StyleService.create({
  title: {
    textAlign: 'center',
    paddingTop: 16,
    paddingBottom: 16,
  },
  content: {
    textAlign: 'center',
    alignSelf: 'center',
  },
  nutritionistPhoto: {
    alignSelf: 'center',
  },
})
